/// <reference path="typings.d.ts" />

import "whatwg-fetch";
import React from "react";
import ReactDOM from "react-dom";
import createFetch from "./utils/createFetch";
import createStore from "./utils/createStore";
import { installFirebasePermissionDeniedDetection, registerFirebasePermissionDeniedStore } from "./utils/firebasePermissionDenied";
import {
  installStaleAuthRecoveryPageshowReset,
  registerStaleAuthRecoveryStore,
} from "./utils/staleAuthRecovery";
import App from "./App";
import ClientRoutes from "./routes";
import RootErrorBoundary from "./toolkit/rootErrorBoundary";
import StyleContext from "isomorphic-style-loader/StyleContext";
import { HelmetProvider } from "react-helmet-async";

const store = createStore(
  window.__INITIAL_STATE__,
  (window as any).App.firebase
);
installStaleAuthRecoveryPageshowReset();
registerFirebasePermissionDeniedStore(store);
registerStaleAuthRecoveryStore(store);
installFirebasePermissionDeniedDetection();
delete window.__INITIAL_STATE__;
const insertCss = (...styles: Array<any>) => {
  // eslint-disable-next-line no-underscore-dangle
  const removeCss = styles.map(x => x._insertCss());
  return () => {
    removeCss.forEach(f => f());
  };
};

// TODO this context is cargo culted from the boilerplate, do we really want this?
// context should be chosen with care, and I don't think that the store should be on the context
//
//
// Global (context) variables that can be easily accessed from any React component
// https://facebook.github.io/react/docs/context.html
const context = {
  insertCss,
  // Enables critical path CSS rendering
  // https://github.com/kriasoft/isomorphic-style-loader
  fetch: createFetch(self.fetch, {
    // TODO why app is on window? where is it defined? do we really care about fetch?
    baseUrl: (window as any).App.apiUrl,
  } as any),
  store,
};

const container = document.getElementById("app");
let appInstance;

try {
  const element = (
    <HelmetProvider>
      <StyleContext.Provider value={{ insertCss }}>
        <App context={context}>
          <RootErrorBoundary store={store}>
            <ClientRoutes />
          </RootErrorBoundary>
        </App>
      </StyleContext.Provider>
    </HelmetProvider>
  );
  appInstance = ReactDOM.hydrate(element, container);
} catch (error) {
  if (__DEV__) {
    throw error;
  }
}

// Enable Hot Module Replacement (HMR) with React Fast Refresh
if ((module as any).hot) {
  (module as any).hot.accept();
}
